<template>
  <main class="privacy-page">
    <router-link to="/">Nvoko home</router-link>
    <h1>Privacy policy</h1>
    <p>
      The privacy policy is currently unavailable. Please contact our legal team
      for the current policy and questions about your personal information.
    </p>
    <a href="mailto:legal@nvoko.com">Contact legal@nvoko.com</a>
  </main>
</template>
<script>
export default { name: "PrivacyPolicy" };
</script>
<style scoped>
.privacy-page {
  min-height: 100vh;
  background: #fff;
  color: #242424;
  padding: 64px max(24px, calc((100vw - 760px) / 2));
  font-size: 17px;
  line-height: 1.7;
}
h1 {
  font-size: 36px;
  margin: 40px 0 24px;
}
p {
  margin-bottom: 24px;
}
a {
  color: #ad003c;
  text-decoration: underline;
}
</style>
